import { createThemeAppConfig } from "@package/util/utils/themeAppConfig";

export const THEME_APP_CONFIG = createThemeAppConfig({
  appName: "agavian-modern",
  themeId: 2,
  themeVariant: "modern",
  displayName: "Modern",
  theme: {
    primaryColor: "#33022f",
    secondaryColor: "#d4af37",
    backgroundColor: "#fff3d9",
    textColor: "#33022f",
    buttonColor: "#33022f",
    buttonHoverColor: "#1a0118",
    buttonTextColor: "#ffffff",
    accentColor: "#d4af37",
    searchBorder: "1px solid rgba(0,0,0,0.1)",
    navbar: {
      backgroundColor: "#33022F",
      backgroundImageAsset: "/assets/images/modernHeader.jpg",
      textColor: "#FDECC8",
      iconColor: "#D4AF37",
      logoColor: "#D4AF37",
      mobileMenuBackgroundColor: "#33022F",
      borderBottom: "1px solid #e8d4dc",
      hoverColor: "#D4AF37",
      search: {
        wrapperBg: "rgba(255, 255, 255, 0.08)",
        wrapperBorder: "1px solid rgba(255, 255, 255, 0.16)",
        inputColor: "#ffffff",
        inputPlaceholder: "rgba(255,255,255,0.68)",
        iconBg: "transparent",
        iconColor: "#D4AF37",
      },
      otpModal: {
        modalBg: "#2a0226",
        heading: "#fdecc8",
        text: "#f8e7bc",
        subtext: "rgba(253, 236, 200, 0.72)",
        border: "rgba(212, 175, 55, 0.35)",
        inputBg: "rgba(255, 255, 255, 0.05)",
        inputText: "#ffffff",
        primaryBtnBg: "#d4af37",
        primaryBtnText: "#33022F",
        secondaryBtnBg: "#fdecc8",
        secondaryBtnText: "#33022F",
        divider: "rgba(253, 236, 200, 0.18)",
      },
    },
    footer: {
      mainBackgroundColor: "#33022F",
      mainBackgroundImageAsset: "/assets/images/modernHeader.jpg",
      mainTextColor: "#FFFFFF",
      brandTextColor: "#D4AF37",
      newsletterInputColor: "#ffffff",
      newsletterPlaceholderColor: "rgba(255, 255, 255, 0.6)",
      newsletterButtonColor: "#D4AF37",
      bottomBorderColor: "rgba(255, 255, 255, 0.1)",
    },
    shippingPromo: {
      background: "linear-gradient(90deg, #33022F 0%, #5A1A57 50%, #33022F 100%)",
      color: "#FDECC8",
      accent: "#D4AF37",
      border: "rgba(212, 175, 55, 0.28)",
      shadow: "0 8px 18px rgba(26, 1, 24, 0.24)",
      letterSpacing: "0.08em",
      minHeight: "42px",
      padding: "0.65rem 1rem",
      gap: "0.85rem",
      dotSize: "6px",
      fontSize: "0.95rem",
      fontWeight: 700,
      textTransform: "uppercase",
      mobileFontSize: "0.82rem",
      mobileTextLetterSpacing: "0.05em",
    },
    hero: {
      sectionBackgroundColor: "#ffffff",
      albumBackgroundColor: "#33022f",
      albumInnerBackgroundColor: "#ffffff",
      textPanelBackgroundColor: "#33022f",
      textPanelBorderColor: "rgba(212, 175, 55, 0.4)",
      titleColor: "#d4af37",
      descriptionColor: "#fdecc8",
      dotColor: "#ddd",
      activeDotColor: "#4a0404",
      ctaBorderColor: "#d4af37",
      ctaShadowColor: "rgba(51, 2, 47, 0.3)",
      ctaHoverShadowColor: "rgba(51, 2, 47, 0.4)",
    },
    journey: {
      sectionBackgroundColor: "#ffffff",
      titleColor: "#3e072b",
      subtitleColor: "#3e072b",
      journeyCard: {
        sideBarColor: "#3e072b",
        cardBackgroundColor: "#fff9e9",
        badgeBorderColor: "#c59c3d",
        badgeBackgroundColor: "#fff9e9",
        badgeTextColor: "#3e072b",
        titleColor: "#3e072b",
        descriptionColor: "#725066",
      },
    },
    testimonials: {
      sectionBackgroundColor: "#ffffff",
      titleColor: "#3e072b",
      subtitleColor: "#3e072b",
      cardBackgroundColor: "#ffffff",
      cardBorderColor: "rgba(0, 0, 0, 0.06)",
      cardShadowColor: "rgba(0, 0, 0, 0.06)",
      cardHoverShadowColor: "rgba(0, 0, 0, 0.1)",
      avatarBackgroundColor: "#3e072b",
      avatarTextColor: "#ffffff",
      nameColor: "#3e072b",
      metaColor: "rgba(62, 7, 43, 0.65)",
      reviewColor: "#333333",
    },
    faq: {
      sectionBackgroundColor: "#FFF3D9",
      titleColor: "#33022F",
      subtitleColor: "#33022F",
      cardBackgroundColor: "#ffffff",
      cardBorderColor: "#33022F",
      questionColor: "#33022F",
      iconColor: "#4A0404",
      answerColor: "#444444",
      answerDividerColor: "#33022F",
    },
    customizedProducts: {
      sectionBackgroundColor: "#FFF3D9",
      titleColor: "#33022F",
      subtitleColor: "#33022F",
      cardBackgroundColor: "#FDECC8",
      cardShadowColor: "rgba(0, 0, 0, 0.1)",
      ringGradientStartColor: "#33022F",
      ringGradientEndColor: "#1A0118",
      ringBorderColor: "#D4AF37",
      innerCardBackgroundColor: "#FFFFFF",
      innerCardBorderColor: "#D4AF37",
      imageBackgroundColor: "#F6F6F6",
      cardTitleColor: "#33022F",
    },
    productsShowcase: {
      sectionBackgroundColor: "#FFF3D9",
      titleColor: "#33022F",
      categoryTitleColor: "#33022F",
      imageShadowColor: "rgba(0,0,0,0.1)",
      productNameColor: "#33022F",
      currentPriceColor: "#33022F",
      originalPriceColor: "#9CA3AF",
      discountBadgeColor: "#047857",
      discountBadgeBackgroundColor: "#DFF3E8",
      ratingBackgroundColor: "#FFF9E6",
      ratingColor: "#F39C12",
    },
    aboutPage: {
      pageBg: "#FFF3D9",
      sectionAlt: "#FFF8EA",
      text: "#33022F",
      muted: "#6B5A67",
      accent: "#D4AF37",
      cardBg: "rgba(255,255,255,0.94)",
      border: "rgba(51, 2, 47, 0.12)",
      shadow: "0 20px 60px rgba(51, 2, 47, 0.10)",
      heroBg:
        "linear-gradient(135deg, rgba(255,243,217,0.95) 0%, rgba(255,255,255,0.98) 55%, rgba(212,175,55,0.18) 100%)",
    },
  },
  surfaces: {
    pageBackground:
      "linear-gradient(135deg, rgba(255,243,217,1) 0%, rgba(255,255,255,0.96) 100%)",
    cardBackground: "rgba(255,255,255,0.94)",
    cardBorder: "1px solid rgba(51, 2, 47, 0.12)",
    cardShadow: "0 20px 60px rgba(51, 2, 47, 0.10)",
  },
  bodyColor: "rgba(51, 2, 47, 0.78)",
});

export const APP_THEME = THEME_APP_CONFIG.theme;
export const APP_MUI_THEME = THEME_APP_CONFIG.muiTheme;
